/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, useEffect, useContext } from "react";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { Col, Row } from "antd";
import clsx from "clsx";
import ServiceApi from "../../services/ServiceApi";
import LayoutMaxi from "../../components/layout_maxi";
// import { useWindowDimensions } from "../../utils/utils";
import { authUserContext } from "../../contexts/authContext";
import { isMobile } from "react-device-detect";
import {useHistory} from 'react-router-dom';
// const isMobile = 450;

const defaultModules = [
  {
    moduleCodes: [1],
    moduleName: "Maxi Infra",
    moduleImage: ServiceApi.absoluteUrl(`/img/modules/module-infra.png`),
    disabledImage: ServiceApi.absoluteUrl(`/img/modules/module-infra-dis.png`),
  },
  {
    moduleCodes: [9],
    moduleName: "Maxi City",
    moduleImage: ServiceApi.absoluteUrl(`/img/modules/module-city.png`),
    disabledImage: ServiceApi.absoluteUrl(`/img/modules/module-city-dis.png`),
  },
  {
    moduleCodes: [2, 4],
    moduleName: "Maxi Operation",
    moduleImage: ServiceApi.absoluteUrl(`/img/modules/module-operation.png`),
    disabledImage: ServiceApi.absoluteUrl(
      `/img/modules/module-operation-dis.png`
    ),
  },
  {
    moduleCodes: [7],
    moduleName: "Maxi Sales",
    moduleImage: ServiceApi.absoluteUrl(`/img/modules/module-sales.png`),
    disabledImage: ServiceApi.absoluteUrl(`/img/modules/module-sales-dis.png`),
  },
  // {
  //   moduleCode: 4,
  //   moduleName: "Maxi Install",
  //   moduleImage: ServiceApi.absoluteUrl(`/img/modules/module-install.png`),
  //   disabledImage: ServiceApi.absoluteUrl(
  //     `/img/modules/module-install-dis.png`
  //   ),
  // },
  {
    moduleCodes: [6],
    moduleName: "Maxi Stock",
    moduleImage: ServiceApi.absoluteUrl(`/img/modules/module-stock.png`),
    disabledImage: ServiceApi.absoluteUrl(`/img/modules/module-stock-dis.png`),
  },
  {
    moduleCodes: [3],
    moduleName: "Maxi Admin",
    moduleImage: ServiceApi.absoluteUrl(`/img/modules/module-admin.png`),
    disabledImage: ServiceApi.absoluteUrl(`/img/modules/module-admin-dis.png`),
  },
];

const SelectModules = () => {
  const { REACT_APP_SITE_INSTALL } = process.env;
  const modules = useSelector((state) => state.modules?.modules);
  // const { width } = useWindowDimensions();
  const authUserValue = useContext(authUserContext);
  const history = useHistory();

  useEffect(() => {
    if (Cookies.get("MaxiToken") === undefined) {
      window.location.assign(ServiceApi.absoluteUrl("/"));
    }
    return () => {};
  }, [modules]);

  // useEffect(() => {
  //   return () => {};
  // }, [width]);

  let url_oper = ServiceApi.absoluteUrl_module(`/ma_list`);

  const selectedModule = async (moduleCode) => {
    // console.log("authUserValue", authUserValue);
    const redirectConfigURL = authUserValue.configuration?.filter(
      (s) => s && s.configuration.general.default_homepage !== null
    )[0]?.configuration.general.default_homepage;

    switch (moduleCode + "") {
      default:
        return null;
      case "1": // ! MaxiInfra
        window.location.assign("http://planb.maxitask.com/Maxiinfra");
        break;
      case "2": // ! MaxiOperation
        console.log("SELECT MODULE", parseInt(Cookies.get("companyid")));
        // if (parseInt(Cookies.get("companyid")) === 3) {
        //   redirectConfigURL && redirectConfigURL !== ""
        //     ? window.location.assign(`${redirectConfigURL}`)
        //     : window.location.assign(ServiceApi.absoluteUrl_module(`/ma_list`));
        //   console.log(
        //     "SELECT MODULE > absoluteUrl_module",
        //     ServiceApi.absoluteUrl_module(`/ma_list`)
        //   );
        //   // window.location.assign(ServiceApi.absoluteUrl_module(`/ma_list`));
        // } else {
        //   console.log("SELECT MODULE > url_oper", url_oper);
        //   window.location.assign(url_oper);
        // }
        // window.location.assign(String(ServiceApi.absoluteUrl_module(`/ma_list`)).replace("undefined/",""));
        history.push("/ma_list")
        break;
      case "3": // ! MaxiAdmin
        window.location.assign("/MaxiAdmin");
        break;
      case "4": // ! Maxiinstall
        window.location.assign(REACT_APP_SITE_INSTALL);
        break;

      case "6": // ! MaxiStock
        window.location.assign("/MaxiStock/warehouse");
        break;
    }
  };
  return (
    <>
      <LayoutMaxi>
        <div className="wrapper-content-operation-home position-relative">
          <div
            className="wrapper-content-operation-cell-home position-relative"
            style={{}}
          >
            <div className="container-fluid">
              <div className="row">
                <Col span={24}>
                  <div className="row">
                    <div
                      style={{
                        position: "fixed",
                        top: "0",
                        right: "0",
                        width: "50%",
                        height: "100%",
                        backgroundColor: "#000F9F",
                        zindex: "-10",
                      }}
                    ></div>
                    <Col span={24}>
                      <Row>
                        <Col
                          span={22}
                          className={clsx("card", !isMobile ? "px-5" : "px-2")}
                          style={{
                            margin: "2.5% 4.5% 0px 4.5%",
                            position: "relative",
                            height: "100%",
                            textAlign: "center",
                            backgroundImage: `url(${ServiceApi.absoluteUrl(
                              "/img/ModuleBG.svg"
                            )})`,
                            backgroundSize: "contain",
                            backgroundPosition: "right",
                            backgroundRepeat: "no-repeat",
                          }}
                        >
                          <div style={{ zIndex: "20" }}>
                            <img
                              src={ServiceApi.absoluteUrl(
                                "/img/MaxiSlogan.svg"
                              )}
                              style={{ width: "auto", height: "100%" }}
                            />
                          </div>
                          <div className="container">
                            <Row type="flex" gutter={[16, 16]}>
                              <Fragment>
                                {defaultModules.map((item, index) => {
                                  const intersectModules = modules
                                    .map((s) => +s.system_code)
                                    .filter((v) =>
                                      item.moduleCodes.includes(v)
                                    );
                                  const disabledModules =
                                    !intersectModules.length;
                                  return (
                                    // <Col key={index} span={8}>
                                    <div className="col-lg-4 col-md-6 col-sm-6">
                                      <button
                                        className={clsx(
                                          !isMobile
                                            ? "btn-module-web"
                                            : "btn-module-mobile"
                                        )}
                                        onClick={() =>
                                          selectedModule(intersectModules[0])
                                        }
                                        disabled={disabledModules}
                                      >
                                        <div
                                          className={
                                            disabledModules ? "" : "img-hover"
                                          }
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            position: "relative",
                                          }}
                                        >
                                          <img
                                            className="img-fluid pic2"
                                            src={
                                              disabledModules
                                                ? item.disabledImage
                                                : item.moduleImage
                                            }
                                          />
                                          {!isMobile && !disabledModules && (
                                            <div className="hover-color"></div>
                                          )}
                                        </div>
                                      </button>
                                    </div>
                                  );
                                })}
                              </Fragment>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </div>
                </Col>
              </div>
            </div>
          </div>
        </div>
      </LayoutMaxi>
    </>
  );
};
export default SelectModules;
